import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RootService } from '../../../core/root.service';
import { ListOptions, Permissions } from '../../../interfaces';
import { takeWhile } from 'rxjs/operators';
import { UtilitiesService } from '@app/shared/services/utilities.service';
import { from, Observable, of } from 'rxjs';
import { PermissionsService } from '@app/core/permissions/permissions.service';
import { RolesPermissionsService } from '@app/core/permissions/roles-permissions.service';

@Component({
  selector: 'app-list-multiple-operations',
  templateUrl: './list-multiple-operations.component.html',
  styleUrls: ['./list-multiple-operations.component.scss'],
})
export class ListMultipleOperationsComponent implements OnInit, OnDestroy {
  // Inputs
  @Input() listOptions: ListOptions;
  @Input() service: RootService;
  alive = true;
  // Local Props
  operations: Operation[];

  @Input() params: any;
  exportAsList = [
    {
      type: 'csv',
      icon: 'file-download-outline',
    },
    // {
    //   type: 'xls',
    //   icon: 'file-download-outline',
    // },
    {
      type: 'xlsx',
      icon: 'file-download-outline',
    },
    {
      type: 'pdf',
      icon: 'file-download-outline',
    },
  ];
  constructor(
    private utilitiesService: UtilitiesService,
    public permissionsService: PermissionsService,
    public rolesPermissionsService:RolesPermissionsService
  ) {}

  /**
   * Implement on init interface because filled data receives from input
   */
  ngOnInit(): void {
    // const permissions = this.permissionsService?.permissions as Permissions;

    // const modulePermissions = permissions[this.service.moduleName];
    this.operations = [
      // {
      //   type: 'archiveMultiple',
      //   icon: 'inbox-arrow-down',
      //   name: 'archive',
      //   permissionKey: false,
      //   condition:
      //     (this.listOptions.archive && !this.listOptions.archivedList) ||
      //     (this.listOptions.archivedFilter && this.service.customFilterActiveLink === 'active'),
      // },

      {
        type: 'deleteMultiple',
        icon: 'deleteMultiple',
        name: 'delete',
        // permissionKey:
        //   (modulePermissions && typeof modulePermissions === 'object' && modulePermissions?.delete) ||
        //   this.permissionsService?.isOwnerPermission ||
        //   false,

        // condition:  this.listOptions.deleteMultiple || this.permissionsService.isOwnerPermission,
      },
      // {
      //   type: 'restoreMultiple',
      //   icon: 'restore',
      //   name: 'restore',
      //   permissionKey: false,
      //   condition:
      //     (this.listOptions.restore && this.listOptions.archivedList) ||
      //     (this.listOptions.archivedFilter && this.service.customFilterActiveLink === 'archived'),
      // },
    ];
    this.filterSubscription();
  }

  ngOnDestroy(): void {
    this.alive = false;
  }

  filterSubscription() {
    this.utilitiesService.filtersObservable$.pipe(takeWhile(() => this.alive)).subscribe(() => {
      // console.log('filter active');
      this.operations.find((x) => x.type === 'archiveMultiple').condition =
        (this.listOptions.archive && !this.listOptions.archivedList) ||
        (this.listOptions.archivedFilter && this.service.customFilterActiveLink === 'active');
      this.operations.find((x) => x.type === 'restoreMultiple').condition =
        (this.listOptions.restore && this.listOptions.archivedList) ||
        (this.listOptions.archivedFilter && this.service.customFilterActiveLink === 'archived');
      this.operations = [...this.operations];
    });
  }
}

/**
 * Local interface for prop: operations
 */
interface Operation {
  type: string;
  icon: string;
  condition?: any;
  name?: string;
  permissionKey?: boolean;
}
